import { FaCogs, FaClipboardCheck, FaBoxOpen, FaHeadset } from 'react-icons/fa';

export const services = [
    {
    icon: <FaCogs />,
    title: "Custom Cable Manufacturing",
    description: "Specializes in tailored cable manufacturing, offering custom designs, lengths, connectors, and shielding to meet unique client specifications."
    },
    {
    icon: <FaClipboardCheck />,
    title: "Custom Packaging and Labeling",
    description: "Offers custom packaging and labeling services to provide branded packaging for our cables."
    },
    {
    icon: <FaBoxOpen />,
    title: "Testing and Quality Control",
    description: "Provides testing and quality control services to ensure that our cables meet or exceed industry standards and customer requirements."
    },
    {
    icon: <FaHeadset />,
    title: "Cable Consultation & Support",
    description: "Provides expert consultation and technical support to help clients select the right cables, troubleshoot issues, and ensure optimal installation and maintenance."
    }
];